import { Box, Grid, hexToRgb } from "@mui/material";
import { FormikValues, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";

import AgeSelection from "./AgeSelection";
import FormStepTitle from "../../form/FormStepTitle";
import DropdownField from "../../../../../common/form/dropdown/DropdownField";
import PatientAdmissionTitleAndInput from "../../form/PatientAdmissionTitleAndInput";

import { gender } from "../../../../../../constants/optionList/gender";
import { GenderSelectBtn, H5 } from "../../../styles";
import { districts } from "../../../../../../constants/patient";

const AdmissionDetails = () => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const districtInputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.value, true);
    if (e.target.name === "district") {
      const selectedDistrictName: any = districts.find(
        (item: string) => item === e.target.value
      );
      if (selectedDistrictName) {
        setFieldValue(
          "DISTRICT_NAME",
          selectedDistrictName.substr(0, 3)?.toUpperCase()
        );
      }
    }
  };

  return (
    <>
      <FormStepTitle title="Admission Details" required />
      <PatientAdmissionTitleAndInput
        title="Patient Name*"
        name="name"
        placeholder="Patient Name"
      />

      <PatientAdmissionTitleAndInput
        title="Parent Name*"
        name="parentsName"
        placeholder="Parent Name*"
      />

      <AgeSelection />

      <H5>Gender*</H5>
      {Object.entries(gender).map(([key, value]) => (
        <GenderSelectBtn
          key={key}
          type="button"
          selected={values?.sex === value?.value}
          onClick={() => setFieldValue("sex", value?.value)}
        >
          {value?.label}
        </GenderSelectBtn>
      ))}

      <Box>
        <Box>
          <H5>District Information*</H5>
          <DropdownField
            name="district"
            label="District Information"
            dropDownList={districts.map((d) => ({ _id: d, name: d }))}
            itemFieldValue="_id"
            itemFieldLabel="name"
            value={values?.district}
            onChange={districtInputHandler}
            sx={{
              "& .MuiInputBase-root": {
                backgroundColor: "#dcdcdc",
                borderRadius: "4px",
              },
            }}
          />
        </Box>
      </Box>

      <PatientAdmissionTitleAndInput
        title="Block*"
        name="village"
        placeholder="Block"
      />

      <PatientAdmissionTitleAndInput
        title="Village/Town/Area*"
        name="address"
        placeholder="Village/Town/Area"
      />
      {/* 
      <PatientAdmissionTitleAndInput
        title="Patient Address*"
        name="address"
        placeholder="Patient Address"
      /> */}

      <PatientAdmissionTitleAndInput
        title="Contact Phone*"
        name="phone"
        placeholder="Patient Phone"
      />

      <PatientAdmissionTitleAndInput
        title="Email"
        name="email"
        type="email"
        placeholder="Patient Email"
      />
    </>
  );
};

export default AdmissionDetails;
